module.exports = __webpack_public_path__ + "img/6_113.5a3acb26.png";